export const iconFontAwesomeWritingFolder = (
	<i className="fa-solid fa-folder"></i>
);
